import React, { useEffect } from 'react'
import _map from 'lodash/map'
import _keys from 'lodash/keys'
import _cloneDeep from 'lodash/cloneDeep'
import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty.js'
import { Field, Form, withFormik } from 'formik'
import { Element, Events, scroller } from 'react-scroll'

import Button from '../../../_library/Button'
import { EVENT_DESCRIPTION_LANGUAGES } from '../../../constants/languages.js'

// cards
import AlternativeViewEventDetails from './AlternativeViewEventDetails'
import AlternativeViewEventVenue from './AlternativeViewEventVenue'
import AlternativeViewEventDescription from './AlternativeViewEventDescription'
import AlternativeViewEventImages from './AlternativeViewEventImages'
import UserReferenceDescription from './UserReferenceDescription'

import { validateAlternativeEvent } from '../../form/EventForm/validation'
import {
  getAlternativeViewFromInitialValues,
  alternativeViewChecks,
  formatUncheckedData,
} from '../../form/EventForm/utils'
import { EventUrlField } from '../../../formik/Fields'
import { requiredValidator, combineValidators, isValidSlug } from '../../../../_common/core/validation'

const languages = getLanguages()
export const defaultLanguage = 'en'
const inValidSlug =
  'Link may only contain alphanumeric characters (a-z, 0-9), underscores (_) and hyphens (-)'

const AlternativeViewForm = props => {
  const {
    event,
    submitLabel,
    isNew,
    isRnDomain,
    cardsStatus,
    onCancel,
    updateResetedDescriptions,
    resetedDescriptions,
    values,
    isSubmitting,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    configs,
    containerId,
  } = props

  /** close autocomplete list on modal scroll **/
  $('.ReactModal__Overlay').on('scroll', () => {
    $('#alternative-view .floating-field-group .floating-field input').blur()
  })

  let eventUrlCopied = false
  const copyEventUrlOut = e => {
    if (eventUrlCopied) {
      setTimeout(() => {
        eventUrlCopied = false
      }, 500)
    }
  }
  const copyEventUrlAfter = () => {
    eventUrlCopied = true
    // this.setState({eventUrlCopied:true})
  }
  const handleChangeImageAsAlternativeEventName = e => {
    const checked = e.target ? e.target.checked : e
    setFieldValue('useImageInsteadOfTitle', checked)
  }
  const handleChangeAlternativeAutoBackground = e => {
    const { checked } = e.target
    setFieldValue('autoBackground', checked)
  }

  useEffect(() => {
    if (!_isEmpty(errors)) {
      Events.scrollEvent.register('end', () => {
        Events.scrollEvent.remove('end')
      })

      scroller.scrollTo('scroll-to-top', {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -120,
        containerId: containerId || null,
      })
    }
  }, [errors, containerId])

  const { autoBackground, useImageInsteadOfTitle, titleReplacementImage } = values
  return (
    <div id="alternative-view">
      <div className="event-form alternative-view-form">
        <div className={!!isNew ? 'body-panel-content' : ''}>
          <Form autoComplete="off">
            <Element name="scroll-to-top" />
            <UserReferenceDescription cardsStatus={cardsStatus} />
            <div className="alternative-view-field">
              <Field
                name="slug"
                label="Alternative View URL"
                isNew={isNew}
                isRnDomain={isRnDomain}
                values={values}
                eventUrlCopied={eventUrlCopied}
                copyEventUrlOut={copyEventUrlOut()}
                copyEventUrlAfter={copyEventUrlAfter()}
                component={EventUrlField}
                validate={combineValidators(requiredValidator(), isValidSlug())}
                inValidSlugClass={errors.slug === inValidSlug ? 'slugfield-holder-with-err' : ''}
              />
            </div>
            <AlternativeViewEventDetails
              event={event}
              cardsStatus={cardsStatus}
              values={values}
              isNew={isNew}
              isRnDomain={isRnDomain}
            />
            <AlternativeViewEventVenue
              closed={true}
              event={event}
              values={values}
              cardsStatus={cardsStatus}
              setFieldValue={setFieldValue}
              configs={_get(configs, 'children.AlternativeViewEventVenue')}
            />
            <AlternativeViewEventDescription
              closed={true}
              event={event}
              values={values}
              setFieldValue={setFieldValue}
              errors={errors}
              touched={touched}
              cardsStatus={cardsStatus}
              resetedDescriptions={resetedDescriptions}
              updateResetedDescriptions={updateResetedDescriptions}
            />
            <AlternativeViewEventImages
              closed={true}
              isAlternativeView={true}
              event={event}
              values={values}
              errors={errors}
              setFieldValue={setFieldValue}
              cardsStatus={cardsStatus}
              autoBackground={autoBackground}
              useImageInsteadOfTitle={useImageInsteadOfTitle}
              handleChangeAlternativeAutoBackground={handleChangeAlternativeAutoBackground}
              handleChangeImageAsAlternativeEventName={handleChangeImageAsAlternativeEventName}
              titleReplacementImage={titleReplacementImage}
            />
            <div className="row">
              <div className="col-xs-12 text-center btn-toolbar">
                <Button
                  className="btn btn-success btn-lg btn-shadow"
                  type="button"
                  loading={isSubmitting}
                  onClick={handleSubmit}
                >
                  {submitLabel}
                </Button>
                <Button
                  className="btn btn-cancel btn-lg btn-shadow"
                  type="button"
                  disabled={isSubmitting}
                  onClick={onCancel}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

export default withFormik({
  mapPropsToValues: props => initialData(props),
  validate: values => validateAlternativeEvent(values),
  handleSubmit: (values, { props, setSubmitting, setValues, setErrors }) => {
    const { useImageInsteadOfTitle } = values
    let formValues = _cloneDeep(values)
    delete formValues.owner
    //set title image field only if set by user
    if (!useImageInsteadOfTitle) {
      formValues.titleReplacementImage = null
      setValues({ ...formValues, titleReplacementImage: null })
    } else {
      const { titleReplacementImage } = formValues
      if (titleReplacementImage && !titleReplacementImage.startsWith('https://')) {
        const { titleReplacementImage } = formValues
        delete formValues.titleReplacementImage
        setValues({ ...formValues, titleReplacementImage })
      }
    }
    formValues = venueData(formValues, values)
    const attributes = checkData(formValues)
    const data = {
      attributes: { ...attributes, eventId: props.formKey },
      relationships: {
        owner: values.owner,
      },
      eventId: props.formKey,
    }
    props
      .onSubmit(data)
      .catch(err => {
        if (err === 'An alternative view with this link already exists - please choose a different one.') {
          setErrors({ slug: 'URL already exists' })
        }
      })
      .finally(() => {
        setSubmitting(false)
      })
  },
})(AlternativeViewForm)

const venueData = (form, data) => {
  const venue = {
    displayName: _get(data, 'venueName') || '',
    streetNumber: _get(data, 'streetNumber') || '',
    street: _get(data, 'street') || '',
    city: _get(data, 'city') || '',
    state: _get(data, 'state') || '',
    postalCode: _get(data, 'postalCode') || '',
    country: _get(data, 'country') || '',
    flagHidden: _get(data, 'flagHidden'),
    flagDisabled: _get(data, 'flagDisabled'),
    googlePlaceId: _get(data, 'googlePlaceId'),
    latitude: _get(data, 'latitude'),
    longitude: _get(data, 'longitude'),
    searchValue: '',
    hideUntil: _get(data, 'hideUntil'),
    locationInformation: _get(data, 'locationInformation') || null,
  }
  delete form.venueName
  delete form.venueId
  const venueProps = Object.keys(venue)
  _map(venueProps, prop => {
    delete form[prop]
  })
  return { ...form, venue }
}

const initialData = props => {
  const values = getAlternativeViewFromInitialValues(props)
  const v = values.backgroundImage
  let languageOptions = _map(_keys(values.descriptions), d => ({
    label: languages[d] + `${d === defaultLanguage ? ' (Default)' : ''}`,
    value: d,
  }))
  if (!languageOptions.length) {
    languageOptions = EVENT_DESCRIPTION_LANGUAGES
  }
  return {
    ...values,
    autoBackground: !v,
    descriptionLanguage: defaultLanguage,
    imageLanguage: defaultLanguage,
    languageOptions,
  }
}

const checkData = values => {
  const imageURLs = !!values.imageURLs ? values.imageURLs : {}
  const descriptions = !!values.descriptions ? values.descriptions : {}
  alternativeViewChecks.forEach(check => {
    if (values[check] === false) {
      values = formatUncheckedData(check, values)
    }
  })
  _map(alternativeViewChecks, field => {
    delete values[field]
  })
  _map(values.languageOptions, locale => {
    if (!values[locale.value + 'Check']) {
      imageURLs[locale.value] = null
    }
    if (!values[locale.value + 'DescriptionCheck']) {
      descriptions[locale.value] = null
    }
    delete values[locale.value + 'Check']
    delete values[locale.value + 'DescriptionCheck']
  })
  values.imageURLs = imageURLs
  values.descriptions = descriptions

  return values
}
